<template>
  <div>
    <el-dialog
      :visible="showDialog"
      width="80%"
      class="chartDia"
      @close="close"
    >
      <div slot="title" class="slotTit">认证信息服务费详情</div>
      <div class="search-box">
        <div class="search-left">
          <div>
            <span>发起方:</span>
            <el-input
              class="search-input"
              placeholder="发起方"
              v-model="searchQuery.sendName"
              clearable
            ></el-input>
          </div>
          <div>
            <span>接收方:</span>
            <el-input
              class="search-input"
              placeholder="接收方"
              v-model="searchQuery.receiveName"
              clearable
            ></el-input>
          </div>
          <div>
            <span>费用类型:</span>
            <el-select
              placeholder="费用类型"
              v-model="searchQuery.costType"
              clearable
            >
              <el-option
                v-for="item in feiyongList"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="search-right">
          <el-button type="primary" @click="searchEvent">搜索</el-button>
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border=""
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="sendName"
          label="发起方"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="receiveName"
          label="接收方"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="costType"
          label="费用类型"
        >
          <template slot-scope="scope">
            {{ scope.row.costType == 1 ? '实名认证费' : '合同签约费' }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="contractType"
          label="合同类型"
        >
          <template slot-scope="scope">
            {{ scope.row.contractType | transType }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createDt"
          label="收费时间"
        >
          <template slot-scope="scope">
            {{ scope.row.createDt | transAllTime }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="price"
          label="费用金额"
        >
          <template slot-scope="scope">
            {{ scope.row.price | moneyFixed }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="操作"
          width="220"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click='check'
            >查看</el-button>
          </template>
        </el-table-column>-->
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
      <el-button @click="close" type="primary">确认</el-button>
    </el-dialog>
    <qualifyChildDetail :showDialog="showDetail"></qualifyChildDetail>
  </div>
</template>
<script>
import qualifyChildDetail from './child/qualifyChildDetail.vue';
import { pageInation } from '@/Mixin/listMixin';
import { authOrderDetailList } from '@/api/ajax';
export default {
  inject: ['itemData'],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  mixins: [pageInation],
  data() {
    return {
      getList: authOrderDetailList, // 获取列表的AJAX
      searchQuery: {
        feiyong: '',
        costOrderId: this.itemData.data.id
      },
      feiyongList: [
        { label: '合同签约费', key: 2 },
        { label: '实名认证费', key: 1 }
      ],
      showDetail: false
    };
  },
  methods: {
    close() {
      this.$parent.componentName = '';
    }
  },
  components: {
    qualifyChildDetail
  },
  filters: {
    transType(v) {
      let s = {
        1: '平台框架协议',
        2: '乙方供应商',
        3: '供应商C端用户',
        4: '甲方乙方结算单'
      };
      return s[v];
    }
  }
};
</script>
